import * as React from 'react';
import './styles.scss';

interface RichTextProps {
  content: string;
  containerTheme: string;
}

const RichText = ({
  content,
  containerTheme,
}: RichTextProps) => (
  <div className={`rich-text rich-text--${containerTheme}`}>
    <div
      className="rich-text__content"
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  </div>
);

export default RichText;
